import { useContext } from 'react';

import { useUpdateSettingsMailroomMutation } from '@api/settings';
import { SettingsContext } from '@contexts/SettingsContext';

export const useUpdateSettingsMailRoom = () => {
  const settings = useContext(SettingsContext);
  const [updateSettings, { isLoading }] = useUpdateSettingsMailroomMutation();

  const updateSettingsMailRoom = async (settingNames: Array<string>, values: Record<string, string | boolean>) => {
    const data = settings
      .filter((setting) => settingNames.includes(setting.name))
      .map((setting) => {
        const name = setting.name;
        return { ...setting, mailroomSettingValue: values[name].toString() };
      });

    return updateSettings(data).unwrap();
  };

  return { updateSettingsMailRoom, isLoading };
};
